import { useParams } from "react-router-dom";

type DynamicURLParams = {
  profileId?: string;
};

export const useAppParams = () => {
  return useParams<DynamicURLParams>();
};
